var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttempt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 8.3,
    viewBox: "0 0 12.8 8.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#54c1e3;}.a{stroke:#54c1e3;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,259a2.193,2.193,0,0,1,.873.176,2.259,2.259,0,0,1,1.2,1.2,2.263,2.263,0,0,1,0,1.749,2.267,2.267,0,0,1-1.2,1.2,2.263,2.263,0,0,1-1.749,0,2.275,2.275,0,0,1-1.2-1.2,2.263,2.263,0,0,1,0-1.749,2.267,2.267,0,0,1,1.2-1.2A2.186,2.186,0,0,1,6,259Zm0,3.75a1.46,1.46,0,0,0,.583-.117,1.511,1.511,0,0,0,.8-.8,1.509,1.509,0,0,0,0-1.166,1.511,1.511,0,0,0-.8-.8,1.509,1.509,0,0,0-1.166,0,1.511,1.511,0,0,0-.8.8,1.509,1.509,0,0,0,0,1.166,1.511,1.511,0,0,0,.8.8A1.46,1.46,0,0,0,6,262.75ZM6,256a6.791,6.791,0,0,1,1.664.208,6.489,6.489,0,0,1,1.559.612,5.9,5.9,0,0,1,1.327,1,5.011,5.011,0,0,1,.97,1.368,4.931,4.931,0,0,1,.357,1A4.565,4.565,0,0,1,12,261.25h-.75a3.9,3.9,0,0,0-.211-1.295,4.074,4.074,0,0,0-.583-1.1,4.667,4.667,0,0,0-.876-.891,5.556,5.556,0,0,0-1.087-.662,5.949,5.949,0,0,0-4.986,0,5.556,5.556,0,0,0-1.087.662,4.667,4.667,0,0,0-.876.891,4.074,4.074,0,0,0-.583,1.1A3.9,3.9,0,0,0,.75,261.25H0a4.565,4.565,0,0,1,.123-1.058,4.931,4.931,0,0,1,.357-1,5.011,5.011,0,0,1,.97-1.368,5.9,5.9,0,0,1,1.327-1,6.489,6.489,0,0,1,1.559-.612A6.791,6.791,0,0,1,6,256Z",
    transform: "translate(0 -256)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(4 3.625)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttempt);
export default __webpack_public_path__ + "static/media/attempt.87aba7b0de400e33c31f07176a48a603.svg";
export { ForwardRef as ReactComponent };